<form [formGroup]="academicYearForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="flex items-center justify-center dialog-header">
        {{type}} Academic Year
        <div class="absolute right-2">
            <button (click)="handleCloseDialog()" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <div class="dialog-content" style="margin-top: -15px;">
            <!-- Year Name -->
            <div class="field">
                <label class="requiredValue">Year Name</label>
                <input pInputText formControlName="year_name" placeholder="Enter Academic Year (e.g. 2025-26)" />
                <small *ngIf="academicYearForm.get('year_name')?.invalid && isSubmitted" class="p-error">
                    Year Name is required
                </small>
            </div>

            <!-- Start and End Date -->
            <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
                <div class="field">
                    <label class="requiredValue">Start Date</label>
                    <p-calendar formControlName="start_date" dateFormat="yy-mm-dd"
                        placeholder="Select Start Date"
                        appendTo="body"
                        class="w-full"
                        [style]="{ width: '100%' }"
                        ></p-calendar>
                    <small *ngIf="academicYearForm.get('start_date')?.invalid && isSubmitted" class="p-error">
                        Start Date is required
                    </small>
                </div>

                <div class="field">
                    <label class="requiredValue">End Date</label>
                    <p-calendar formControlName="end_date" 
                    class="w-full"
                    appendTo="body"
                    dateFormat="yy-mm-dd"
                    [style]="{ width: '100%' }"
                        placeholder="Select End Date"></p-calendar>
                    <small *ngIf="academicYearForm.get('end_date')?.invalid && isSubmitted" class="p-error">
                        End Date is required
                    </small>
                </div>
            </div>

            <!-- Status -->
            <div class="field">
                <label class="requiredValue">Status</label>
                <p-select [options]="statusOptions" formControlName="status" placeholder="Select Status"></p-select>
                <small *ngIf="academicYearForm.get('status')?.invalid && isSubmitted" class="p-error">
                    Status is required
                </small>
            </div>

            <!-- Action buttons -->
            <div class="flex justify-end gap-2 mt-8">
                <p-button label="Cancel" severity="danger" variant="outlined" (click)="handleCloseDialog()"></p-button>
                <p-button label="Save" icon="pi pi-save" [loading]="btnLoading" [disabled]="btnLoading"
                    (click)="onSubmit()"></p-button>
            </div>
    </div>
</form>